import React from "react";
import { Prompt } from "react-router";
import Modal from "../../commonComponents/util/Modal";
import LoadingSpinner from "../../commonComponents/util/LoadingSpinner";
import FadeOutErrorMessage from "../../commonComponents/util/FadeOutErrorMessage";

export default class CompletePrintingModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      printing: false,
      error: false,
      awaitConfirm: true
    };
  }

  async confirmPrintJob(isCancel) {
    this.setState({ error: false });

    await this.props.confirmPrint(isCancel);
    if (this.props.confirming.success) {
      this.close();
    } else {
      this.setState({ error: true });
    }
  }

  async reprint() {
    this.setState({ error: false, awaitConfirm: false });

    await this.props.reprint();

    if (this.props.reprinting.success) {
      this.setState({ awaitConfirm: true });
    } else {
      this.setState({ error: true });
    }
  }

  close() {
    this.props.close();
    this.setState({
      error: false,
      awaitConfirm: false
    });
  }

  render() {
    return (
      <Modal modalShowing={this.props.show}>
        <Prompt
          when={this.props.show}
          message="Are you sure you'd like to leave this page before confirming printing?  You will not be able to confirm printing at a later point."
        />
        <div className="modal-container">
          <div className="modal print-modal small-modal">
            <h4 className="page-header text-center">Printing</h4>
            <img className="modal-img" src="/images/Print.png" alt="print" />
            {this.props.printInfo.length > 0 && (
              <div className="printing-options">
                <p className="medium-text">
                  <i className="icon ion-ios-checkmark-outline accent-text icon-left" />
                  Check #{this.props.printInfo[0].checkNumber}
                </p>
                <p className="medium-text">
                  <i
                    className={`icon ion-ios-${
                      this.props.printInfo[0].card ? "checkmark" : "close"
                    }-outline accent-text icon-left`}
                  />
                  Card
                </p>
              </div>
            )}
            {this.state.awaitConfirm && (
              <span className="print-confirmation">
                Print job has completed. <br /> Click Finish to confirm
                printing. <br /> Click Cancel if printing was unsuccessful.
              </span>
            )}
            {this.props.confirming.loading ||
            (this.props.allowReprint && this.props.reprinting.loading) ? (
              <LoadingSpinner height="20" />
            ) : (
              <div>
                <button
                  className="btn btn-primary btn-fullWidth"
                  onClick={this.confirmPrintJob.bind(this)}
                >
                  Finish
                </button>
                {this.props.allowReprint && (
                  <button
                    className="btn btn-accent btn-fullWidth mb-16"
                    onClick={this.reprint.bind(this)}
                  >
                    Reprint
                  </button>
                )}
                <button
                  className="btn btn-danger btn-fullWidth"
                  onClick={this.confirmPrintJob.bind(this, true)}
                >
                  Cancel
                </button>
              </div>
            )}
            <FadeOutErrorMessage show={this.state.error} />
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/recipientAccountDetails/CompletePrintingModal.jsx